import { authorizedApi } from './index';

export const onrampTransactionsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getOnrampTransactions: builder.query({
      query: ({ page_key, page_size, start_date, end_date } = {}) => {
        const params = {};
        if (page_key != null && page_key !== '') params.page_key = page_key;
        if (page_size != null) params.page_size = page_size;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        return {
          url: '/admin/onramp-transactions',
          method: 'GET',
          params,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetOnrampTransactionsQuery, useLazyGetOnrampTransactionsQuery } =
  onrampTransactionsApi;
